<template>
  <div>
    <vx-card>
      <List :subjectPermission="subjectPermission"></List>
    </vx-card>
  </div>
</template>

<script>
import List from "./ListEmpresas";

export default {
  data() {
    return {
      subjectPermission: "Empresas",
    };
  },
  methods: {},
  components: {
    List,
  },
};
</script>
